var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInputInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 25C19.6274 25 25 19.6274 25 13C25 6.37258 19.6274 1 13 1C6.37258 1 1 6.37258 1 13C1 19.6274 6.37258 25 13 25Z",
    stroke: "#B1B1B1",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.332 16.333C14.035 16.333 14.643 15.839 14.643 15.041C14.643 14.737 14.757 14.471 15.08 14.11L16.258 12.799C16.98 12.02 17.284 11.279 17.284 10.31C17.284 8.353 15.726 6.871 13.465 6.871C11.527 6.871 10.178 7.878 9.741 9.246C9.684 9.417 9.646 9.607 9.646 9.759C9.646 10.462 10.14 10.918 10.862 10.918C11.356 10.918 11.812 10.652 12.078 10.082C12.325 9.512 12.705 9.151 13.408 9.151C14.168 9.151 14.662 9.664 14.662 10.405C14.662 10.88 14.472 11.317 13.902 11.944L12.876 13.103C12.192 13.863 12.04 14.433 12.04 15.041C12.04 15.839 12.61 16.333 13.332 16.333ZM11.774 18.651C11.774 19.506 12.477 20.209 13.332 20.209C14.187 20.209 14.89 19.506 14.89 18.651C14.89 17.796 14.187 17.093 13.332 17.093C12.477 17.093 11.774 17.796 11.774 18.651Z",
    fill: "#B1B1B1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInputInfo);
export default __webpack_public_path__ + "static/media/input-info.e5653bfd168214c937c4456f83f9c74c.svg";
export { ForwardRef as ReactComponent };